import { useAuth } from 'reactfire';

const useUserId = () => {
  const auth = useAuth();
  return auth.currentUser?.uid as string;
};

export default useUserId;
